'use strict';

var loader   = require('helpers/loader');
var tooltip  = require('helpers/tooltip');
var modal    = require('helpers/modal');
import Log from 'lib/log.js';
const log = Log('list-editables');

module.exports = Backbone.View.extend({
    events: function() {
        return {
            'click .js-save':   'save',
            'click .js-cancel': 'cancel',
            'click .js-add':    'add'
        };
    },

    modelViews: [],

    modalEditView: null,

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            template: null,
            templateExtra: false,
            Model: null,
            ModelView: null,
            ModalEditView: null
        });

        if (!_.isNull(this.options.ModalEditView)) {
            this.modalEditView = new this.options.ModalEditView({
                actOnSave:    false,
                actOnCancel:  false,
                actOnDestroy: false
            });
        }

        if (this.collection) {
            this.bindHandlers();
            this.render();
        }

        return this;
    },

    bindHandlers: function() {
        this.collection.on('reset', this.render, this);
        this.collection.on('add remove destroy', this.toggleEmptyMessage, this);
        this.collection.on('add', this.renderModel, this);

        if (this.modalEditView) {
            this.modalEditView.on(
                'saved', (model) => {
                    this._original = null;
                    try {
                        this.collection.add(model);
                    } catch (e) {
                        // ignore, the model is already in the collection
                    }
                }, this
            );
            this.modalEditView.on(
                'cancelled', (model) => {
                    if (this._original) {
                        model.set(this._original, {silent: true});
                        this._original = null;
                        this.renderModels();
                    }
                }, this
            );
        }

        return this;
    },

    unbindHandlers: function() {
        this.collection.off(null, null, this);
        if (this.modalEditView) {
            this.modalEditView.off(null, null, this.collection);
        }
        return this;
    },

    render: function() {
        if (!this.options.template) {
            log.info('No template present');
            return this;
        }

        if (!this.collection) {
            log.info('No collection present');
            return this;
        }

        this.$el.html(this.options.template(_.defaults({
            collection: this.collection
        }, this.options.templateExtra || {})));

        this.renderModels();

        this.toggleEmptyMessage();

        tooltip.init(this);

        return this;
    },

    renderModels: function() {
        if (!this.options.ModelView) {
            return this;
        }

        if (!this.collection) {
            return this;
        }

        this.removeModelViews();
        this.collection.each((model) => {
            if (!this.options.filter ||
                (this.options.filter && this.options.filter(model))) {
                this.renderModel(model);
            }
        });

        return this;
    },

    renderModel: function(model) {
        // TODO i think listeditables are not flexible enough
        var view = new this.options.ModelView({
            model: model,
            additional: this.options
        });

        this.$('.js-model-views').append(view.$el);
        this.modelViews.push(view);

        view.on('edit', this.showEditModal, this);

        return this;
    },

    showEditModal: function(model) {
        this._original = Object.assign({}, model.attributes);
        this.modalEditView.setModel(model).show();
    },

    toggleEmptyMessage: function() {
        this.$('.js-empty').toggleClass('hidden', (
            _.isObject(this.collection) && this.collection.length > 0
        ));

        return this;
    },

    add: function(ev) {
        var model = this.createModel();
        ev.preventDefault();

        if (!this.modalEditView) {
            log.info('No modal edit view present');
            return this;
        }

        if (!model) {
            log.info('No model could be created');
            return this;
        }

        this.modalEditView.setModel(model).show();

        return this;
    },

    createModel: function() {
        if (!this.options.Model) {
            log.info('Mising model constructor');
            return false;
        }

        return new this.options.Model();
    },

    removeModelViews: function() {
        _.each(this.modelViews, function(view) {
            view.off(null, null, this);
            view.remove();
            view = null;
        });
        this.modelViews = [];

        return this;
    },

    remove: function() {
        Backbone.View.prototype.remove.apply(this, arguments);

        this.undelegateEvents();

        if (this.collection) {
            this.unbindHandlers();
        }

        if (this.modalEditView) {
            this.modalEditView.remove();
        }

        this.removeModelViews();

        this.$el.remove();
    },

    save: function(ev) {
        let stopLoader = () => {};
        if (ev) {
            stopLoader = loader.startFullScreen(this.$(ev.currentTarget));
        }

        this.trigger('save', this.collection);
        return this.collection.save()
            .then(() => {
                this.trigger('saved', this.collection);
                modal.showAlertSuccess('Your changes have been saved');
            })
            .finally(stopLoader);
    },

    cancel: function(ev) {
        let stopLoader = () => {};
        if (ev) {
            stopLoader = loader.startFullScreen(this.$(ev.currentTarget));
        }
        this.collection.fetch({reset: true}).finally(stopLoader);
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/ListEditables.js